'use client';
import { motion } from 'motion/react';
import { ArrowRight } from 'lucide-react';

const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0 },
};

export default function CallToAction() {
  return (
    <section
      id="cta"
      className="relative overflow-hidden bg-foreground py-24 sm:py-32"
      aria-labelledby="cta-heading"
    >
      {/* Amber glow from top */}
      <div
        className="pointer-events-none absolute inset-0"
        aria-hidden="true"
        style={{
          background:
            'radial-gradient(ellipse at 50% -20%, hsl(30 95% 52% / 0.12), transparent 60%)',
        }}
      />
      {/* Subtle texture */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.03]"
        aria-hidden="true"
        style={{
          backgroundImage:
            'radial-gradient(hsl(0 0% 100%) 1px, transparent 1px)',
          backgroundSize: '32px 32px',
        }}
      />

      <div className="relative mx-auto max-w-3xl px-5 text-center sm:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5 }}
          variants={fadeUp}
        >
          <h2
            id="cta-heading"
            className="font-serif text-3xl font-700 leading-tight text-background sm:text-4xl md:text-5xl"
          >
            Stop guessing.
            <br />
            Start <span className="text-accent">knowing.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-background/60 sm:text-lg">
            Join the FMCG leaders who replaced their morning ritual with
            10 minutes of perfect clarity.
          </p>

          <div className="mt-8">
            <a
              href="mailto:hello@supe.market?subject=Demo%20Request"
              className="inline-flex items-center gap-2.5 rounded-full bg-background px-8 py-4 text-sm font-semibold text-foreground transition-opacity hover:opacity-90 focus-visible:ring-2 focus-visible:ring-background focus-visible:ring-offset-2 focus-visible:ring-offset-foreground"
            >
              Request a Demo
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </a>
          </div>

          <p className="mt-6 text-xs text-background/40">
            No credit card required &middot; Setup in under a week &middot;
            Dedicated onboarding
          </p>
        </motion.div>
      </div>
    </section>
  );
}
